<template>
    <div class="row g-3 mb-4">
        <!-- NAGŁÓWEK W SPÓJNYM STYLU -->
        <div class="col-12 d-flex justify-content-between align-items-center border-bottom pb-2 cursor-pointer" @click="toggleSection">
            <h6 class="fw-bold mb-0">10. Podpis</h6>
            <button type="button" class="btn btn-sm btn-link text-decoration-none p-0">
                <i class="bi" :class="sectionCollapse ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
            </button>
        </div>

        <!-- TREŚĆ SEKCJI -->
        <div class="col-12" v-show="sectionCollapse">
            <div class="row border rounded py-3">
                <div class="col-md-6 border-end text-center p-3">
                    <label class="fw-semibold d-block mb-3">Osoba upoważniona do wystawienia dokumentu</label>
                    <input type="text" class="form-control text-center mx-auto" style="max-width: 300px;" v-model="form.issuerName" placeholder="Imię i nazwisko" />
                </div>
                <div class="col-md-6 text-center p-3">
                    <label class="fw-semibold d-block mb-3">Osoba upoważniona do odbioru dokumentu</label>
                    <input type="text" class="form-control text-center mx-auto" style="max-width: 300px;" v-model="form.receiverName" placeholder="Imię i nazwisko" />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, computed } from 'vue'

const props = defineProps({
    modelValue: {
        type: Object,
        required: true
    }
})

const emit = defineEmits(['update:modelValue'])

const form = computed({
    get: () => props.modelValue,
    set: (val) => emit('update:modelValue', val)
})

const sectionCollapse = ref(false)
const toggleSection = () => {
    sectionCollapse.value = !sectionCollapse.value
}
</script>

<style scoped>
.cursor-pointer {
    cursor: pointer;
    user-select: none;
}
</style>